import React from 'react'
import PropTypes from 'prop-types'

class PhoneNumberTr extends React.Component {
  render() {
    return(
      <tr>
        <th className='fix-table-width'>
          {this.props.fieldName}
        </th>
        <td>
          {this.props.fieldValue ? (
            <a className='styled-link pointer-hand'
               href={'tel:' + this.props.fieldValue}>
              {this.props.fieldValue}
            </a>
          ) : (
            '-'
          )}
        </td>
      </tr>
    )
  }
}

PhoneNumberTr.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.string
}

export default PhoneNumberTr
